export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/windows_mobile_app.8adad8b.svg";